import axios from "axios";
import { getToken, logout } from "./api";

export default class ApiRequest {
  constructor(config) {
    this.config = config;
    this.apiUrl = config.apiBaseUrl
      ? config.apiBaseUrl
      : `${config.scheme}://${config.url}/${config.api_version}`;
  }

  doGetRequest(
    apiPath,
    params = {},
    headers = {},
    {
      returnParam = false,
      skipCache = false,
      bypassCache = false,
      resCallback = null,
    } = {},
    cancelToken
  ) {
    return new Promise((resolve, reject) => {
      if (!headers.hasOwnProperty("Content-Type")) {
        headers["Content-Type"] = "application/x-www-form-urlencoded";
      }

      if (skipCache) {
        params["timestamp"] = new Date().valueOf();
      }

      if (bypassCache) {
        params["admin_cache_bypass"] = new Date().valueOf();
      }

      axios
        .get(`${this.apiUrl}${apiPath}`, {
          params,
          headers,
          cancelToken,
        })
        .then((res) => {
          res = res.data;
          if (returnParam) {
            res = res[returnParam];
          }
          if (typeof resCallback === "function") {
            res = resCallback(res);
          }

          resolve(res);
        })
        .catch(function(error) {
          if (axios.isCancel(error)) {
            // Request was canceled, do nothing
            return;
          }

          if (error.response?.data?.error === "Invalid JWT") {
            logout();
          } else {
            reject(error);
          }
        });
    });
  }

  doPutRequest(
    apiPath,
    params = {},
    headers = {},
    {
      returnParam = false,
      skipJWT = false,
    } = {}
  ) {
    return new Promise((resolve, reject) => {
      if (!headers.hasOwnProperty("Content-Type")) {
        headers["Content-Type"] = "application/x-www-form-urlencoded";
      }
      if (
        !skipJWT &&
        !headers.hasOwnProperty("X-Harness-JWT") &&
        !headers.hasOwnProperty("Authorization")
      ) {
        headers["X-Harness-JWT"] = getToken();
      }

      axios
        .put(`${this.apiUrl}${apiPath}`, params, {
          headers,
        })
        .then((res) => {
          if (returnParam) {
            resolve(res.data[returnParam]);
          } else {
            resolve(res.data);
          }
        })
        .catch(function(error) {
          if (error.response?.data) {
            if (error.response.data?.error === "Invalid JWT") {
              logout();
            } else {
              reject(error.response.data);
            }
          } else {
            reject(error);
          }
        });
    });
  }

  doPostRequest(
    apiPath,
    params = {},
    headers = {},
    {
      returnParam = false,
      skipJWT = false,
    } = {}
  ) {
    return new Promise((resolve, reject) => {
      if (!headers.hasOwnProperty("Content-Type")) {
        headers["Content-Type"] = "application/x-www-form-urlencoded";
      }
      if (
        !skipJWT &&
        !headers.hasOwnProperty("X-Harness-JWT") &&
        !headers.hasOwnProperty("Authorization")
      ) {
        headers["X-Harness-JWT"] = getToken();
      }

      axios
        .post(`${this.apiUrl}${apiPath}`, params, {
          headers,
        })
        .then((res) => {
          if (returnParam) {
            resolve(res.data[returnParam]);
          } else {
            resolve(res.data);
          }
        })
        .catch(function(error) {
          if (error.response?.data) {
            if (error.response.data?.error === "Invalid JWT") {
              logout();
            } else {
              reject(error.response.data);
            }
          } else {
            reject(error);
          }
        });
    });
  }

  doDeleteRequest(
    apiPath, 
    headers = {}, 
    { 
      returnParam = false, 
      skipJWT = false 
    } = {}
  ) {
    return new Promise((resolve, reject) => {
      if (!headers.hasOwnProperty("Content-Type")) {
        headers["Content-Type"] = "application/x-www-form-urlencoded";
      }
      if (
        !skipJWT &&
        !headers.hasOwnProperty("X-Harness-JWT") &&
        !headers.hasOwnProperty("Authorization")
      ) {
        headers["X-Harness-JWT"] = getToken();
      }

      axios
        .delete(`${this.apiUrl}${apiPath}`, {
          headers,
        })
        .then((res) => {
          if (returnParam) {
            resolve(res.data[returnParam]);
          } else {
            resolve(res.data);
          }
        })
        .catch(function(error) {
          if (error.response?.data) {
            if (error.response.data?.error === "Invalid JWT") {
              logout();
            } else {
              reject(error.response.data);
            }
          } else {
            reject(error);
          }
        });
    });
  }
}

export { axios };
